import { ArrowRight, Calendar, Clock, Eye, Mic } from "lucide-react";
import React, { useState } from "react";
import {
  get_blog_type_for_feature,
  getReadingTime,
} from "../../../../../utils/Constant";
import { s3baseUri } from "../../../../../config/config";
import CustomPopoverSection from "../../../../../components/menu/MebuCustomPopOverSection";
import CustomConfirmation from "../../../../../components/popUp/CustomConfirmation";
import { delete_blog } from "../../../../../DAL/blogs/BlogList";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../../../../hook/AdminContext";
import SharePostPopup from "../../../../../components/cards/SharePostPopup";
import CustomPopoverNew from "../../../../../components/CustomPopoverNew";
import { useParams } from "react-router-dom";
import CustomModalLayout from "../../../../../components/modal/CustomModalLayout";
import {
  arrow,
  book_blue_icon,
  calender,
  calender_blue_icon,
  calenderBack,
  clock,
  clockBack,
  eye,
  eye_blue_icon,
  mic,
  writer,
} from "../../../../../assets";
import moment from "moment";
import ActionByChip from "../../../../../components/cards/ActionByChip";

export default function InsightCard({
  handleOpenEditCoach = () => {},
  handleGetInsightListing = () => {},
  handleInsightClick = () => {},
  post,
  isPodcastCard = false,
}) {
  console.log(post, "postpostpostpostpostpost");

  const actionByName = post?.action_by?.company_name
    ? post?.action_by?.company_name
    : post?.action_by?.first_name && post?.action_by?.last_name
    ? `${post?.action_by?.first_name || ""} ${post?.action_by?.last_name || ""}`
    : "";
  console.log(actionByName, "actionByNameactionByNameactionByName");
  const { feature_slug } = useParams();
  const {
    userInfo,
    handleGetSectorAccessValue,
    handleReportPost,
    handleGetActionByStatus,
  } = useIds();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [openSharePost, setOpenSharePost] = useState(false);

  const handleDelete = async () => {
    const resp = await delete_blog(post.slug);
    if (resp.code == 200) {
      handleGetInsightListing();
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setDeleteDialogOpen(false);
  };

  const handleDeleteConfimation = () => {
    setDeleteDialogOpen(true);
  };

  const handleNavigateReportJob = () => {
    handleReportPost(post, "insight", () => handleGetInsightListing());
  };

  const handleOpenSharePost = () => {
    setOpenSharePost(true);
  };

  const handleMenuOptions = () => {
    if (isPodcastCard) {
      return [];
    } else if (post.created_by == "admin") {
      return [
        {
          label: "Share Insight",
          icon: "mdi:share-outline",
          handleClick: () => {
            handleOpenSharePost(post);
          },
        },
      ];
    } else if (
      post?.client_object?._id === userInfo?.profile_id &&
      handleGetSectorAccessValue(get_blog_type_for_feature(feature_slug)) &&
      ((userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.manage_profile?.company_profile))
    ) {
      const MENU_OPTIONS = [
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick() {
            handleOpenEditCoach(post);
          },
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: () => handleDeleteConfimation(),
        },

        {
          label: "Share Insight",
          icon: "mdi:share-outline",
          handleClick: () => {
            handleOpenSharePost(post);
          },
        },
      ];
      return MENU_OPTIONS;
    } else {
      let MenuList = [];
      MenuList.push({
        label: "Share Insight",
        icon: "mdi:share-outline",
        handleClick: () => {
          handleOpenSharePost(post);
        },
      });
      if (post?.client_object?._id != userInfo?.profile_id) {
        MenuList.push({
          label: "Report Insight",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        });
      }
      return MenuList;
    }
  };

  return (
    <>
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this insight?"}
        headerHeading={"Delete Insight"}
        handleAgree={() => handleDelete()}
      />
      {openSharePost && (
        <CustomModalLayout
          open={openSharePost}
          onClose={() => setOpenSharePost(false)}
          title={isPodcastCard ? "Share Podcast" : "Share Insight"}
          width="550px"
          componentToPass={
            <SharePostPopup
              postData={{
                ...post,
                _id: post.slug,
                description: post.title,
              }}
              type={"insight"}
            />
          }
        />
      )}
      <div className="">
        <div
          key={post._id}
          onClick={() => handleInsightClick(post)}
          className=" row blog-card cursor-pointer insight-card p-0"
        >
          {/* Image */}
          <div className="col-12 col-md-4 col-lg-3 p-3">
            <img
              src={
                post?.image[0]?.thumbnail_2
                  ? s3baseUri + post?.image[0]?.thumbnail_2
                  : ""
              }
              alt={post.title}
              className="img-fluid w-100 card-img"
            />
            {/* {post.category[0]?.title && (
              <div className="">
                <h6 className="font-medium">
                  {post.category[0]?.title}
                </h6>
              </div>
            )} */}
          </div>

          {/* Content */}
          <div className="col-12 col-md-8 col-lg-9 p-3 pt-4 pb-5 pb-lg-0">
            <div>
              <div className="d-flex justify-content-between align-items-start heading-main-hr">
                <div>
                  <h2 className="font-medium mb-0">{post.title}</h2>
                  <p
                    className={`mb-0 text-gray size-sm ${
                      isPodcastCard ? "text-base" : ""
                    }`}
                  >
                    {isPodcastCard ? post.podcast_name : post.short_description}
                  </p>
                </div>
                <div className="d-flex flex-column align-items-end flex-shrink-0 ms-2">
                  <div className="d-flex align-items-center">
                    {post?.client_object?._id === userInfo?.profile_id && (
                      <>
                        {!post.status && (
                          <span
                            className={`outlined-chip error-badge d-block tw-mr-2`}
                          >
                            {"Inactive"}
                          </span>
                        )}
                        <div className="outlined-chip success me-1">
                          My Insight
                        </div>
                      </>
                    )}
                    {handleMenuOptions().length > 0 && (
                      <CustomPopoverSection
                        menu={handleMenuOptions()}
                        data={post}
                      />
                    )}
                  </div>
                  <div>
                    {actionByName &&
                      userInfo?.profile_id === post?.client_object?._id && (
                        <ActionByChip
                          className="new-chip--outlined new-chip"
                          actionByName={actionByName}
                        />
                      )}
                  </div>
                </div>
              </div>

              <div className="podcast-icons flex-wrap pt-3">
                <div className="">
                  <img src={calender_blue_icon} className="img-fluid" />

                  <span className="ps-2">
                    {moment(post?.createdAt).format("DD MMM, YYYY")}
                  </span>
                </div>
                {(post.duration || post.read_time) && (
                  <div className="">
                    <img src={book_blue_icon} className="img-fluid" />

                    <span className="ps-2">
                      {isPodcastCard ? post.duration : post.read_time}
                    </span>
                  </div>
                )}
                {/* {post?.writer && (
                  <div className="pt-2">
                    <img src={writer} className="img-fluid icon-background" />
                    <span>{post?.writer}</span>
                  </div>
                )} */}
                {post?.play_count ? (
                  <div className="">
                    <img
                      src={eye_blue_icon}
                      className="img-fluid icon-background"
                    />
                    <span className="ps-2">{post.play_count}</span>
                  </div>
                ) : (
                  ""
                )}
                {post?.view_count ? (
                  <div className="">
                    <img src={eye} className="img-fluid icon-background" />
                    <span className="ps-2">{post.view_count}</span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="tw-flex tw-items-center tw-justify-end insight-read-more-btn">
              <button className="small-button-cotain-view-all">
                {isPodcastCard ? "View Podcast" : "Read Article"}
                <img
                  src={arrow}
                  alt=""
                  className="img-fluid ms-3"
                  height={18}
                  width={18}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
